<template>
  <header class="m-header" v-if="show">
    <section
      :class="{
        'm-header-fixed': true,
        fixed: fixed
      }"
    >
      <div class="m-header-content">
        <div class="m-header-left" @click="goBack">
          <icon name="weibiaoti--" />
        </div>
        <h1 class="m-header-title" :key="title">
          <span>{{ navTitle }}</span>
        </h1>
        <div class="m-header-right">
          <template v-if="$slots.right">
            <slot name="right" />
          </template>
          <template v-else v-for="(item, index) in btnList">
            <span class="m-header-right-btn" :key="index">
              {{ item.showName }}
            </span>
          </template>
        </div>
      </div>
      <slot name="bottom" />
    </section>
  </header>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default() {
        return this.platform ? !this.platform.isYixinliApp : true
      }
    },
    // native topFuncBtnConfig btnList
    // web 按照需求传入
    btnList: {
      type: Array,
      default() {
        return []
      }
    },
    title: {
      type: String
    },
    fixed: {
      type: Boolean,
      default: false
    },
    autoGoback: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  mounted() {
    const watchs = {
      btnList: () => {
        this.$bridge.topFuncBtnConfig({
          btnList: this.btnList
        })

        this.$bridge.topFuncBtn = obj => {
          const target = this.btnList[obj.name]
          if (target && typeof target.callback === 'function') {
            target.callback(obj)
          }
        }
      },
      // title: () => {
      //   this.$bridge.setTitle({
      //     title: this.title
      //   })
      // },
      autoGoback: () => {
        this.$bridge.allowJSControlGoback = {
          isAllowed: this.autoGoback ? 0 : 1
        }
      }
    }
    for (let item in watchs) {
      if (typeof watchs[item] === 'function') {
        watchs[item]()
        this.$watch(item, watchs[item])
      }
    }
  },
  methods: {
    goBack() {
      if (this.autoGoback) {
        this.routerGoback()
      } else {
        this.$emit('goback', this.routerGoback)
      }
    }
  },
  computed: {
    navTitle() {
      return this.title || this.$store.state.meta.title
    }
  },
  watch: {
    // btnList() {
    //   this.$bridge.topFuncBtnConfig({
    //     btnList: this.btnList
    //   })
    // },
    // title() {
    //   this.$bridge.setTitle({
    //     title: this.title
    //   })
    // },
    // autoGoback() {
    //   this.$bridge.allowJSControlGoback = {
    //     isAllowed: this.autoGoback
    //   }
    // }
  }
}
</script>

<style lang="scss">
.m-header {
  $h: 90px;
  height: $h;
  .m-header-fixed {
    box-sizing: border-box;
    height: $h;
    width: 100%;
    position: relative;
    &:before {
      position: absolute;
      height: 1px;
      background: #f3f4f5;
      bottom: 0;
      left: 0;
      right: 0;
      content: '';
    }
    &.fixed {
      position: fixed;
      left: 0;
      z-index: $navbarZIndex;
    }
  }
  .m-header-content {
    display: flex;
    align-items: stretch;
    height: $h;
    /* background-color: #118bd0; */
    background-color: #fff;
    color: #333;
  }
  .m-header-left,
  .m-header-title,
  .m-header-right {
    flex: 1;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }
  .m-header-left {
    .icon-node-website {
      font-size: 32px;
    }
  }
  .m-header-right {
    justify-content: flex-end;
  }
  .m-header-title {
    justify-content: center;
    font-size: 36px;
    flex: 1.5;
    overflow: hidden;
    span {
      @include overLine();
    }
  }
  .m-header-right-btn {
    font-size: 26px;
  }
}
</style>
